import { render } from "./Edit_1.vue?vue&type=template&id=070b9d7c&scoped=true"
import script from "./Edit_1.vue?vue&type=script&lang=js"
export * from "./Edit_1.vue?vue&type=script&lang=js"

import "./Edit_1.vue?vue&type=style&index=0&id=070b9d7c&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070b9d7c"]])

export default __exports__